const cartClickEvents = () => {
	cartAddToList();
	emptyCart();
	impulseBuy();
};

function cartAddToList() {
	const cartAddToListLink = document.getElementById('cartAddToList');
	triggerEvent(cartAddToListLink, 'cartAddToList_Click');
}

function emptyCart() {
	const emptyCartLink = document.getElementById('emptyCart');
	triggerEvent(emptyCartLink, 'emptyBasket_Click');

	const emptyCartConfirmButton = document.getElementById(
		'cartEmptyModalActionLink',
	);
	triggerEvent(emptyCartConfirmButton, 'emptyBasket_Confirm');

	const emptyCartAddToListLink = document.getElementById(
		'cartEmptyModalAddToList',
	);
	triggerEvent(emptyCartAddToListLink, 'emptyBasket_CartAddToList');
}

function impulseBuy() {
	const impulseProduct = document.getElementById('impulseProduct');
	const impulseProductSubmit = document.getElementById('impulseProductSubmit');

	if (!impulseProduct) return;
	const sku = impulseProduct.getAttribute('data-product-sku');

	triggerLoadEvent(impulseProduct, 'impulseBuy_Loaded', { sku });
	triggerEvent(impulseProductSubmit, 'impulseBuy_Click', { sku });
}

function triggerEvent(domNode, eventName, data = {}) {
	if (!domNode) return;

	const eventData = Object.assign({ url: window.location.href }, data);

	domNode.addEventListener('click', () => {
		window.od.events.publish(eventName, eventData);
	});
}

function triggerLoadEvent(domNode, eventName, data = {}) {
	if (!domNode) return;

	const eventData = Object.assign({ url: window.location.href }, data);

	window.od.events.publish(eventName, eventData);
}

export default cartClickEvents;
